import React from 'react';
import inflection from 'inflection';
import { MenuItemLink } from 'react-admin';
import DefaultIcon from '@material-ui/icons/ViewList';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  itemLink: {
    width: '100%'
  }
});

const TranslatedResourceName = (resource: any, translate: any) =>
  translate(`resources.${resource.name}.name`, {
    smart_count: 2,
    _:
      resource.options && resource.options.label
        ? translate(resource.options.label, {
          smart_count: 2,
          _: resource.options.label,
        })
        : inflection.humanize(inflection.pluralize(resource.name)),
  });

type Props = {
  classes: any,
  dense: boolean,
  onMenuClick: any,
  resource: any,
  translate: any
};

const LeftMenuLink = (props: Props) => (
  <MenuItemLink
    className={props.classes.itemLink}
    key={props.resource.name}
    to={`/${props.resource.name}`}
    primaryText={TranslatedResourceName(props.resource, props.translate)}
    leftIcon={
      (props.resource.options && props.resource.options.leftIcon) ? props.resource.options.leftIcon : <DefaultIcon />
    }
    onClick={props.onMenuClick}
    dense={props.dense}
  />
);

export default withStyles(styles)(LeftMenuLink);



// WEBPACK FOOTER //
// ./src/views/Framework/LeftMenuLink.tsx